import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import Methode from "@/pages/Methode";
import Prestations from "@/pages/Prestations";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";
import Structures from "@/pages/Structures";

const PAGE_TITLES = {
  "/": "L'effet poilus — Le coaching familial à l'aide de l'animal",
  "/methode": "La Méthode — L'effet poilus",
  "/prestations": "Prestations & Tarifs — L'effet poilus",
  "/a-propos": "À propos de Sophie Reitzer — L'effet poilus",
  "/structures": "Structures & professionnels — L'effet poilus",
  "/contact": "Contact — L'effet poilus",
  "/mentions-legales": "Mentions légales — L'effet poilus",
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = PAGE_TITLES[pathname] || PAGE_TITLES["/"];
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function LenisProvider() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function App() {
  return (
    <div className="App bg-cream">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <LenisProvider />
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/methode" element={<Methode />} />
            <Route path="/prestations" element={<Prestations />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/structures" element={<Structures />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
